/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { navigate } from 'gatsby';

import updatePersonFields from '~actions/updatePersonFields';
import * as Sentry from '@sentry/gatsby';
import queryParam from '../../utils/queryparams';
import axios from '../../utils/axios';

import navigateToSecondStep from './navigateToSecondStep';

function Resume() {
  const dispatch = useDispatch();

  useEffect(() => {
    let cancelled = false;
    const uuid = queryParam('uuid');
    const token = queryParam('token');
    const skipOVR = !!queryParam('skip_ovr');

    if (!uuid && !token) {
      // Since this relies on external info (`token`) and is already in a `useEffect`
      // hook, it can be an exception and avoid calling `useRegisterRedirect`
      navigate('/tools/register/', { replace: true });
      return () => {};
    }

    const requestParams = uuid ? { uuid } : { token };
    axios
      .get('registration/resume_token/', {
        params: requestParams,
      })
      .then(({ data }) => {
        if (cancelled) {
          return Promise.resolve();
        }

        return dispatch(updatePersonFields({ state: data.state })).then(() => {
          if (cancelled) {
            return;
          }

          dispatch({
            type: 'REGISTER_UPDATE_FIELDS',
            registerFields: {
              uuid: data.uuid,
              action_id: data.action_id,
              ovr_link: data.ovr_link,
            },
          });

          navigateToSecondStep({
            skipOVR,
            replace: true,
          });
        });
      })
      .catch((err) => {
        if (cancelled) {
          return;
        }

        Sentry.captureException(err);
        // eslint-disable-next-line no-console
        console.error(err);
        // This `navigate` should be fine as it is still inside the `useEffect` hook
        navigate('/tools/register/', { replace: true });
      });

    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  return <h1>Loading...</h1>;
}

export default Resume;
